__turbopack_context__.v({
  "logo-image-wrapper-span": "styles-module__lMscba__logo-image-wrapper-span",
  "marker-wrapper": "styles-module__lMscba__marker-wrapper",
  "steps-wrapper": "styles-module__lMscba__steps-wrapper",
});
